import { observer } from 'mobx-react'
import React, { Component, Fragment } from 'react'
import styled from 'styled-components'
import Medication from './Medication'
import Text from '../../components/Text'
import patient from '../../stores/patient'
import Header from './Header'

const PlanBox = styled.div`
  border: 1px solid var(--gray);
  page-break-inside: avoid;
  border-radius: 1rem;
  overflow: hidden;
  margin: 2rem 0;
  flex-shrink: 0;
  align-self: stretch;
  break-inside: avoid;
  @media print {
    font-size: 0.75rem;
  }
`

const Divider = styled.div`
  height: 1px;
  width: 100%;
  border-bottom: 1px solid var(--gray);
`

const VerticalDivider = styled.div`
  align-self: stretch;
  width: 1px
  border-right: 1px solid var(--gray);
  flex-shrink: 0;
`

const TimePlace = styled.div`
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 1.25em;
  font-weight: 500;
  flex-shrink: 0;
  width: 25%;
  & > *:not(:last-child) {
    margin-bottom: 0.75rem;
  }
  & > * {
    flex-shrink: 0;
  }
`

const TimeImage = styled.img`
  max-width: 4rem;
  margin-bottom: 1rem;
`

const Place = styled.div`
  font-size: 0.9em;
  opacity: 0.7;
  text-align: center;
`

const Routine = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1.75;
  font-size: 1.1rem;
  padding: 1rem;
  white-space: pre-wrap;
  
  @media print {
    font-size: 0.75rem;
    line-height: 1.25;
  }
`

const Row = styled.div`
  display: flex;
  align-items: center;
`

const MedicationsWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  flex-wrap: wrap;
`

const PlanContainer = styled.div`
  margin-top: -1.5rem;
`

const sunriseSrc = '/images/time2/sunrise.png'
const daySrc = '/images/time2/day.png'
const sunsetSrc = '/images/time2/sunset.png'
const nightSrc = '/images/time2/night.png'
const otherSrc = '/images/time2/other.png'

function getTimeImageSrc(time, period) {
  const t = parseInt(time, 10)
  if (isNaN(t)) {
    return otherSrc
  }
  if (t < 6) {
    return period === 'AM' ? nightSrc : daySrc
  }
  if (t < 10) {
    return period === 'AM' ? sunriseSrc : sunsetSrc
  }
  if (t === 12) {
    return period === 'AM' ? nightSrc : daySrc
  }
  return period === 'AM' ? daySrc : nightSrc
}

@observer
export default class Plans extends Component {
  render() {
    return (
      <Fragment>
        <Header str="titles.dailyRoutine" style={{ marginTop: '0' }} />
        <PlanContainer>
        {patient.fields.plans.map((p, i) => (
          <PlanBox key={i}>
            <Row>
              <TimePlace>
                <TimeImage
                  alt=""
                  src={getTimeImageSrc(p.time, p.timePeriod)}
                />
                {!isNaN(parseInt(p.time, 10)) &&
                  <strong>{p.time}{' '}{p.timePeriod}</strong>
                }
                {p.location !== 'OTHER' && <Place>
                  <Text str={`choices.location.${p.location}`} />
                </Place>}
              </TimePlace>
              <VerticalDivider />
              {p.medications.length > 0 &&
                <MedicationsWrap>
                  {patient.fields.medications.map((m, i2) => (
                    <Fragment key={i2}>
                      {p.medications.includes(m.prescription) && <Medication medication={m} />}
                    </Fragment>
                  ))}
                </MedicationsWrap>
              }
            </Row>
            {p.routine &&
              <Fragment>
                <Divider />
                <Routine>{p.routine}</Routine>
              </Fragment>
            }
          </PlanBox>
        ))}
        </PlanContainer>
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Print/Plans.js